<script lang="ts">
  import { mdiTrashCanOutline } from '@mdi/js';
  import MaterialIcon from '../../../website/src/lib/MaterialIcon.svelte';
  import Button from '../../../website/src/lib/components/Button.svelte';
  import RhythmButtonPanel from './RhythmButtonPanel.svelte';
  import { createEventDispatcher } from 'svelte';
  import type { ButtonColor } from '../../../website/src/lib/components/ButtonDefinitions';

  const dispatch = createEventDispatcher();
  export let submitText = 'Check';
  export let dotDisabled = false;
  export let deleteDisabled = false;
  export let disabled = false;
  export let textColor = 'white';
  export let buttonColor: ButtonColor = 'orange';
  let clazz = '';
  export { clazz as class };
</script>

<RhythmButtonPanel {disabled} class={clazz} {dotDisabled} on:click>
  <Button
    color={buttonColor}
    disabled={deleteDisabled || disabled}
    on:click={() => dispatch('click', 'delete')}
    ><MaterialIcon path={mdiTrashCanOutline} />
    <span class="sr-only">Delete</span>
  </Button>
  <Button {disabled} on:click={() => dispatch('click', 'check')}>
    <span style="color: {textColor}">{submitText}</span>
  </Button>
</RhythmButtonPanel>
